<template>
  <v-dialog
    max-width="290px"
    v-model="dialog"
    open-on-focus
    transition="dialog-transition"
    data-testid="date-range-dialog"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="element"
        dense
        outlined
        :label="label || 'Date Range'"
        clearable
        v-on="on"
        :error-messages="error"
        class=""
        :value="formattedRangevalue"
        @click:clear="
          content = [];
          tempContent = [];
          updateValue();
        "
        :hide-details="hidedetails"
        :disabled="disabled"
        data-testid="date-range-dialog__text-field"
      ></v-text-field>
    </template>
    <v-card elevation="0" flat tile data-testid="date-range-dialog__card">
      <v-card-text class="pa-0" data-testid="date-range-dialog__card-text">
        <v-date-picker
          elevation="0"
          v-model="tempContent"
          range
          color="primary"
          data-testid="date-range-dialog__date-picker"
        >
          <v-spacer data-testid="date-range-dialog__spacer"></v-spacer>
          <v-btn
            text
            data-testid="date-range-dialog__close-btn"
            @click="
              dialog = false;
              tempContent = content;
              updateValue();
            "
            class="secondaryBtn"
          >
            <span data-testid="date-range-dialog__close-btn-text">Close</span>
          </v-btn>
          <v-btn
            elevation="0"
            color="primary"
            data-testid="date-range-dialog__ok-btn"
            @click="
              content = tempContent;
              dialog = false;
              updateValue();
            "
            :disabled="tempContent.length != 2"
          >
            <span data-testid="date-range-dialog__ok-btn-text">Ok</span>
          </v-btn>
        </v-date-picker>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  activated() {
    this.setValue();
    this.updateValue();
  },
  created() {
    this.setValue();
    this.updateValue();
  },
  data: () => ({
    formattedvalue: "",
    dialog: false,
    content: [],
    tempContent: [],
  }),
  props: {
    error: {
      type: [String, Array],
    },
    label: {
      type: String,
    },
    value: {
      type: Array,
    },
    hidedetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // required: {
    //   type: Boolean,
    //   default: false
    // }
  },
  methods: {
    setValue: function () {
      let v = [];
      if (this.value instanceof Array) {
        for (let i = 0; i < this.value.length; i++) {
          const el = this.value[i];
          if (!isNaN(new Date(el))) v.push(this.$nova.formatDateISO(el));
        }
      }
      this.content = v;
    },
    updateValue: function () {
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    setFocus: function () {
      this.$nextTick(() => {
        this.$refs.element.$el.querySelector("input").focus();
      });
    },
    setBlank: function () {
      this.content = [];
      this.tempContent = [];
    },
  },
  computed: {
    formattedRangevalue() {
      let v = this.$nova.formatDate(this.content);
      let dt = v.toString().split(",");
      if (dt.length === 2) return dt.join(" - ");
      else {
        this.setBlank();
        return "";
      }
    },
  },
  watch: {
    value: function () {
      this.setValue();
    },
  },
};
</script>